import React, { ReactNode } from "react";
import Style from "./SimpleCenteredLayout.scss";

interface SimpleCenteredLayoutProps {
  children?: ReactNode;
}

const SimpleCenteredLayout: React.FC<SimpleCenteredLayoutProps> = ({ children }) => {
    return (
        <div className={Style.Container}>
            <div className={Style.ContentWrapper}>{children}</div>
        </div>
    );
};

export default SimpleCenteredLayout;
